(() => {
  function updateLinks(card, variantId) {
    card.querySelectorAll('[data-card-link]').forEach((a) => {
      const href = a.getAttribute('href') || '';
      try {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('variant', variantId);
        a.setAttribute('href', url.toString());
      } catch (e) {}
    });
  }

  function findCardImage(card) {
    return (
      card.querySelector('img[data-card-image]') ||
      card.querySelector('.product-card__image--main img') ||
      card.querySelector('.product-card__image img')
    );
  }

  function updateImage(card, variantImageUrl) {
    if (!variantImageUrl) return;

    const img = findCardImage(card);
    if (!img) return;

    img.src = variantImageUrl;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');

    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((s) => {
        s.removeAttribute('srcset');
        s.removeAttribute('data-srcset');
      });
    }
  }

  function updateSku(card, sku) {
    if (!sku) return;
    const el = card.querySelector('[data-card-sku]');
    if (el) el.textContent = sku;
  }

  function setActiveSwatch(container, active) {
    container.querySelectorAll('[data-swatch]').forEach((btn) => {
      const isActive = btn === active;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initCard(card) {
    const swatches = card.querySelector('[data-card-swatches]');
    if (!swatches) return;

    swatches.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-swatch]');
      if (!btn) return;

      e.preventDefault();

      const variantId = btn.dataset.variantId;
      const variantImg = btn.dataset.variantImage;
      const variantSku = btn.dataset.variantSku;

      if (!variantId) return;

      updateLinks(card, variantId);
      updateImage(card, variantImg);
      updateSku(card, variantSku);
      setActiveSwatch(swatches, btn);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-card-product]').forEach(initCard);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
